export default __webpack_public_path__ + "static/media/twitter-outline.8cb9365c.svg";